import React, { useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { cx } from "@/components/FormFields";

export function AccountPanel({ input }) {
  const { admin } = useAuth();
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (nw !== confirm) { toast.error("New passwords do not match."); return; }
    if (nw.length < 8) { toast.error("New password must be at least 8 characters."); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: nw });
      toast.success("Password updated.");
      setCur(""); setNw(""); setConfirm("");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Could not update password.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md">
      <div className="rounded-xl border border-[#232f25] bg-[#111712] p-6 mb-6">
        <h3 className="font-display text-lg font-bold text-white tracking-tight">Account Owner</h3>
        <p className="text-sm text-[#9EABA0] mt-1">{admin?.email}</p>
        <p className="text-[11px] text-[#69776b] mt-1">Role: {admin?.role}</p>
      </div>
      <form onSubmit={submit} className="rounded-xl border border-[#232f25] bg-[#111712] p-6 space-y-4" data-testid="change-password-form">
        <h3 className="font-display text-lg font-bold text-white tracking-tight">Reset Password</h3>
        {[["Current Password", cur, setCur, "current-password"], ["New Password", nw, setNw, "new-password"], ["Confirm New Password", confirm, setConfirm, "confirm-password"]].map(([label, val, set, tid]) => (
          <div key={tid}>
            <label className="block text-xs font-semibold uppercase tracking-wide text-[#9EABA0] mb-1.5">{label}</label>
            <input type="password" value={val} onChange={(e) => set(e.target.value)} className={cx(input, "w-full")} data-testid={`account-${tid}`} required />
          </div>
        ))}
        <button type="submit" disabled={busy} className="px-6 py-2.5 rounded-md bg-[#8CE63C] text-[#080b08] text-sm font-bold hover:bg-[#9df04f] transition-colors disabled:opacity-50" data-testid="account-save-password">
          {busy ? "Updating…" : "Update Password"}
        </button>
      </form>
    </div>
  );
}
